import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { MAP_BACKGROUND_OPTIONS as g } from "./index.es684.js";
import { Close as d } from "@radix-ui/react-popover";
import { useTheme as C } from "./index.es190.js";
import { FlexContainer as t } from "./index.es584.js";
import { IconContainer as a } from "./index.es158.js";
import { Icon as l } from "./index.es157.js";
import { IconButton as b } from "./index.es16.js";
import { UtilityChevronIcon as u } from "./index.es439.js";
import { Heading as v } from "./index.es507.js";
const y = "popover-template-basic-header", A = ({
  icon: s,
  onCloseSequence: c,
  onActionClick: o,
  actionIconType: p,
  onBack: i,
  title: h,
  backgroundColor: f = "white",
  testId: r = y
}) => {
  const { spacings: n } = C();
  return /* @__PURE__ */ m(
    t,
    {
      padding: `${n.md} ${n.lg}`,
      alignItems: "center",
      style: { backgroundColor: g[f] },
      width: "100%",
      justifyContent: "space-between",
      testId: r,
      children: [
        /* @__PURE__ */ m(t, { alignItems: "center", gap: n.xxs, children: [
          s && /* @__PURE__ */ e(a, { size: 32, color: "transparent", onClick: i, children: /* @__PURE__ */ e(
            l,
            {
              ...s,
              size: 24,
              allowHoverState: !1,
              testId: r + "-icon"
            }
          ) }),
          i && /* @__PURE__ */ e(
            b,
            {
              variant: "ghost",
              size: "small",
              onClick: i,
              testId: r + "-back",
              Icon: /* @__PURE__ */ e(u, { direction: "right", type: "bold" }),
              "aria-label": "Go back"
            }
          ),
          /* @__PURE__ */ e(v, { variant: "h6", testId: r + "-title", element: "span", children: h })
        ] }),
        c && !o && /* @__PURE__ */ e(t, { style: { cursor: "pointer" }, children: /* @__PURE__ */ e(
          d,
          {
            "aria-label": "Close",
            onClick: c,
            "data-testid": r + "-close",
            children: /* @__PURE__ */ e(a, { size: 32, color: "transparent", children: /* @__PURE__ */ e(l, { size: 16, type: "X", weight: "outline" }) })
          }
        ) }),
        p && o && /* @__PURE__ */ e(t, { style: { cursor: "pointer" }, children: /* @__PURE__ */ e(
          d,
          {
            "aria-label": "Popover Header Action",
            onClick: o,
            "data-testid": r + "-action",
            children: /* @__PURE__ */ e(a, { size: 32, color: "transparent", children: /* @__PURE__ */ e(l, { size: 24, type: p }) })
          }
        ) })
      ]
    }
  );
};
export {
  y as POPOVER_TEMPLATE_BASIC_HEADER_TEST_ID,
  A as PopoverTemplateBasicHeader
};
//# sourceMappingURL=index.es685.js.map
